// Keep "Selected initial" in sync with the chosen letter
(function () {
  function updateSelectedInitial() {
    // find the checked Letter radio
    var selected = document.querySelector('input[type="radio"][name="Letter"]:checked');
    if (!selected) return;

    // read its label text (the visible letter)
    var label = document.querySelector('label[for="' + selected.id + '"]');
    var letter = (label ? label.textContent : selected.value || '').trim();

    // update the UI text
    var strongEl = document.querySelector('#celestia-selected-initial strong');
    if (strongEl && letter) {
      strongEl.textContent = letter;
    }
  }

  // run once on load
  document.addEventListener('DOMContentLoaded', updateSelectedInitial);

  // run whenever the Letter option changes
  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'Letter') {
      updateSelectedInitial();
    }
  });
})();
